"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.motion = void 0;
// Animation timing values. Exposed for use in js-based animations.
const timing = {
  default: 200
};
const easing = {
  default: "cubic-bezier(0.3, 0.3, 0.2, 1)"
};
const animation = {
  default: `200ms ${easing.default}`
};
const motion = {
  easing,
  animation,
  timing
};
exports.motion = motion;
//# sourceMappingURL=motion.js.map